import {useSearchParams, useNavigate, useLocation} from 'react-router-dom'
import {CreateUpdateForm} from 'template'

export default function Update() {
  const fields = [
    {name: 'etinama', label: 'Nama', type: 'text', required: true},
    {name: 'etiketerangan', label: 'Keterangan', type: 'text', required: true},
  ]

  const [searchParams] = useSearchParams()
  const uid = searchParams.get('dctid')
  const etiid = searchParams.get('etiid')
  const navigate = useNavigate()
  const location = useLocation()
  const initialData = location?.state?.item || ''

  const apiEndpoint = `${
    process.env.REACT_APP_BASE_URL_DOKTER
  }/prd-data-etiket/${!!initialData ? 'update' : 'create'}`

  const apiParams = !!initialData ? {etiid, etiaktif: 1} : {}

  return (
    <>
      <CreateUpdateForm
        fields={fields}
        apiEndpoint={apiEndpoint}
        initialData={initialData || ''}
        label={initialData ? 'Ubah Data Etiket' : 'Tambah Data Etiket'}
        apiParams={{uid, reg: 'dbdok', a: 'dk13', ...apiParams}}
        onSuccess={() => navigate('/prd-data-etiket?dctid=' + uid)}
        onCancel={() => navigate('/prd-data-etiket?dctid=' + uid)}
      />
    </>
  )
}
